// removed by extract-text-webpack-plugin
module.exports = {"Container":"_R3RH5"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/AutoSuggestBox/AutoSuggestBox.scss
// module id = 878
// module chunks = 0